import { render, staticRenderFns } from "./WhiteListAdded.vue?vue&type=template&id=316c8bd8&scoped=true"
import script from "./WhiteListAdded.vue?vue&type=script&lang=js"
export * from "./WhiteListAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316c8bd8",
  null
  
)

export default component.exports